import { createTypes } from "redux-action-types";


const CARE_BALANCE = "CARE_BALANCE";

export const CARE_BALANCE_ACTION_TYPES = createTypes(
  CARE_BALANCE + "_",
  "SET_SINGLE_TRANSACTION"
);

export const setSingleTransaction = (transaction) => {
  return {
    type: CARE_BALANCE_ACTION_TYPES.SET_SINGLE_TRANSACTION,
    payload: transaction,
  };
};

export const getCareBalanceSelectors = (state) => {
  const { singleTransaction } = state.careBalance || {};
  return { singleTransaction };
};
